import UserApi from '../../rest-api/user-api';

export async function isDuplicateClinicPatientId({ bearerToken, clinicPatientId, currentPatientId = null }) {
    if (!clinicPatientId?.trim()) return false;

    const response = await UserApi.getPatientsByFilter(bearerToken, {
        filterType: 'clinicPatientId',
        filterValue: clinicPatientId.trim(),
    });

    const matches = response?.patients || [];

    return matches.some((p) => p.clinicPatientId === clinicPatientId.trim() && p.patientId !== currentPatientId);
}
